import { ReactNode } from 'react';

import { cx } from '@libs/classnames';
import { FancyBadge } from '@ui/components/FancyBadge';

import { MediaDevices } from '@features/video/hooks/useMediaDevices';
import { MediaDeviceSettings } from '@features/video/ui/MediaDeviceSettings';

import styles from './StreamSetup.module.css';

export type Props = {
  className?: string;
  devices: MediaDevices;
  // трек для индикатора уровня в эфире; без него уровень с захвата
  meterTrack?: MediaStreamTrack | null;
  mirrored?: boolean;
  hint?: ReactNode;
  // ошибка связи; ошибки устройств показывает сам выбор устройств
  error?: string | null;
  isJoining?: boolean;
  joinLabel?: string;
  onJoin?: () => void;
  onCancel?: () => void;
  // в эфире: под настройками статус и управление вместо кнопки входа; смена устройства
  // в эфире уходит в комнату сама
  live?: ReactNode;
};

// Камера с микрофоном до трансляции и в эфире: настройки одни и те же, меняется только
// низ — кнопка входа или управление стримом
export function StreamSetup({
  className,
  devices,
  meterTrack,
  mirrored,
  hint,
  error,
  isJoining,
  joinLabel = 'Подключиться',
  onJoin,
  onCancel,
  live,
}: Props) {
  const canJoin = devices.status === 'ready' && !isJoining;

  return (
    <div className={cx(styles.setup, className)}>
      <MediaDeviceSettings
        video
        audio
        hint={hint}
        mirrored={mirrored}
        devices={devices}
        meterTrack={meterTrack}
      />

      {error && <p className={styles.setup__error}>{error}</p>}

      <div className={styles.setup__footer}>
        {live ?? (
          <>
            <FancyBadge className={styles.setup__join} disabled={!canJoin} onClick={onJoin}>
              {isJoining ? 'Подключение...' : joinLabel}
            </FancyBadge>
            {onCancel && <FancyBadge onClick={onCancel}>Назад</FancyBadge>}
          </>
        )}
      </div>
    </div>
  );
}
